module.exports = __webpack_public_path__ + "static/media/super-mais.f79c93a1.svg";